<template>
  <div class="root">
   <div class="welcome-tomamu">
    <img src="/images/tomamu_top/welcomeTomamu.png" class="full-width" />
   </div>
    <v-layout column wrap align-center class="container">
      <div class="full-width">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <div
            :class="'btn-lang'+' btn-language_'+$i18n.locale"
            ontouchstart
            v-on="on"
          />
          </template>
          <language-list />
        </v-menu>
      </div>
      <v-layout row wrap class="container max-width">
        <v-flex v-if="!isGenerateMode" xs6>
          <div class="btn-title-qr">
            <img :src="'/images/tomamu_top/QRType_'+$i18n.locale+'.png'" class="full-width btn-title-qr-image"/>
          </div>
          <div
            class="img-btn btn-qr"
            ontouchstart
            @click="goToQRSite"
          />
        </v-flex>
        <v-flex xs6>
          <div class="btn-title-boarding-position">
            <img :src="'/images/tomamu_top/boardingPositionType_'+ $i18n.locale +'.png'" :class="$i18n.locale === 'en' ? 'btn-title-boarding-position-image-en full-width': 'btn-title-boarding-position-image full-width'"/>
          </div>
          <div
            class="img-btn btn-boarding-position-check"
            ontouchstart
            @click="goToSearch"
          />
          <div class="zhtw-caution">
            <img v-if="$i18n.locale === 'zhtw'" src="/images/tomamu_top/boardingPositionTypeZh.png" class="full-width zhtw-caution-image"/>
          </div>
        </v-flex>
        <v-flex xs6>
        <div class="btn-title-status">
          <img :src="'/images/tomamu_top/statusType_'+$i18n.locale+'.png'" :class="($i18n.locale === 'ko')||($i18n.locale === 'en')? 'btn-title-status-image-large full-width' :'btn-title-status-image full-width'"/>
        </div>
          <div
            class="img-btn btn-status"
            ontouchstart
            @click="onClickStatus"
          />
          <div class="zhtw-caution">
            <img v-if="$i18n.locale === 'zhtw'" src="/images/tomamu_top/statusTypeZh.png" class="full-width zhtw-caution-image"/>
          </div>
        </v-flex>
      </v-layout>
    </v-layout>
    <div class="jr-logo">
      <img :src="'/images/tomamu_top/jrLogo_'+ $i18n.locale + '.png'" class="full-width" />
    </div>
    <service-status-dialog ref="serviceStatusDialog"/>
  </div>
</template>

<script>
import BaseComponent from '@/components/BaseComponent'
import LanguageList from '@/components/LanguageList'
import ServiceStatusDialog from '@/components/ServiceStatusDialog'
import Api from '@/lib/Api'

export default {
  name: 'Top',
  extends: BaseComponent,
  components: {
    LanguageList,
    ServiceStatusDialog
  },
  data: () => {
    return {
      isGenerateMode: false
    }
  },
  beforeMount () {
    if (!this.isDistanceValidated()) {
      this.$router.push({ name: 'Caution' })
    }
    Api.getUriMode().then(result=> this.isGenerateMode = result)
  },
  methods: {
    goToSearch () {
      this.$router.push({ name: 'Search' })
    },
    onClickStatus () {
      this.$refs.serviceStatusDialog.open()
    },
    goToQRSite(){
      const defaultLanguage = this.$i18n.locale === "zh" ? "zhcn" : this.$i18n.locale
      window.location.href = `/tomamu/info-qr/?param=st&defaultLanguage=${defaultLanguage}`
    }
  },
}
</script>

<style lang="scss" scoped>
.root {
  padding-top: 16px;
}
.container {
  padding: 16px;
}
.max-width{
  max-width:375px;
}
.full-width {
  display: block;
  width: 100%;
}
.btn-lang {
  margin-top:16px;
  margin-left:16px;
  padding: 8px;
  height:48px;
  max-width:128px
}
.welcome-tomamu {
  margin:0 32px;
}
.img-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 92px;
  padding: 8px;
  margin:4px auto;
  height: 92px;
}
.btn-title-qr{
  position: relative;
  height:32px;
  margin:0 16px;
}
.btn-title-qr-image{
  position: absolute;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 90%;
}
.btn-title-boarding-position{
  position: relative;
  height:32px;
  margin:0 16px;
}
.btn-title-boarding-position-image{
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 70%;
}
.btn-title-boarding-position-image-en{
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 100%;
}

.btn-title-status{
  position: relative;
  height:32px;
  margin:0 16px;
}
.btn-title-status-image{
  position: absolute;
  top: 8px;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 50%;
}
.btn-title-status-image-large{
  position: absolute;
  top: 8px;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 90%;
}
//言語設定ボタンのstyle,
//sassでi18nのstate受け取る方法が分からず冗長に記述してる
.btn-language_ja {
  background-image: url(/images/tomamu_top/languageButton_ja.png);
  background-size: contain;
  &:active {
    background-image: url(/images/tomamu_top/languageButtonPush_ja.png);
  }
}
.btn-language_en {
  background-image: url(/images/tomamu_top/languageButton_en.png);
  background-size: contain;
  &:active {
    background-image: url(/images/tomamu_top/languageButtonPush_en.png);
  }
}
.btn-language_zh {
  background-image: url(/images/tomamu_top/languageButton_zh.png);
  background-size: contain;
  &:active {
    background-image: url(/images/tomamu_top/languageButtonPush_zh.png);
  }
}
.btn-language_zhtw {
  background-image: url(/images/tomamu_top/languageButton_zhtw.png);
  background-size: contain;
  &:active {
    background-image: url(/images/tomamu_top/languageButtonPush_zhtw.png);
  }
}
.btn-language_ko {
  background-image: url(/images/tomamu_top/languageButton_ko.png);
  background-size: contain;
  &:active {
    background-image: url(/images/tomamu_top/languageButtonPush_ko.png);
  }
}
//
.btn-qr {
  background-image: url(/images/tomamu_top/QRButton.png);
  background-size: contain;
  &:active {
    background-image: url(/images/tomamu_top/QRButtonPush.png);
  }
}
.btn-boarding-position-check {
  background-image: url(/images/tomamu_top/boardingPositionButton.png);
  background-size: contain;
  &:active {
    background-image: url(/images/tomamu_top/boardingPositionButtonPush.png);
  }
}
.btn-status {
  background-image: url(/images/tomamu_top/statusButton.png);
  background-size: contain;
  clear: both;
  &:active {
    background-image: url(/images/tomamu_top/statusButtonPush.png);
  }
}
.zhtw-caution {
  position: relative;
  height:16px;
  margin:0 16px;
}
.zhtw-caution-image {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 70%;
}
.jr-logo {
  margin:0 32px;
  margin-bottom:16px;
}
</style>
